module.exports = __webpack_public_path__ + "media/media/home/_img1-aaee498df1d37804419097f83d92c5c9.png";